/**
 * Team-Rufnummern (Paul 08.10.2026: „ich finde es komisch wie man das format
 * einträgt"). Gespeichert bleibt das bisherige Textformat in
 * `tenants.telefon_namen` — eine Zeile `nummer = name`, das lesen Backend
 * (sipgate-Namen, WhatsApp-Zuordnung, Inhaber anschreiben) und Voice-Agent.
 * Hier nur Umwandlung Text ⇄ Tabellenzeilen. Die Rolle steht hinten in
 * Klammern: „Arman (Inhaber)".
 */
export const ROLLEN = ["Inhaber", "Büro", "Monteur", "Mitarbeiter"] as const
export type Rolle = (typeof ROLLEN)[number] | ""
export type TeamZeile = { nummer: string; name: string; rolle: Rolle }

const ROLLE_HINTEN = new RegExp(`\\s*\\((${ROLLEN.join("|")})\\)\\s*$`)

export function textZuZeilen(text: string): TeamZeile[] {
  return (text || "").split(/\r?\n/).map((z) => z.trim()).filter(Boolean).map((z) => {
    const i = z.indexOf("=")
    const nummer = (i >= 0 ? z.slice(0, i) : z).trim()
    let name = i >= 0 ? z.slice(i + 1).trim() : ""
    let rolle: Rolle = ""
    const m = name.match(ROLLE_HINTEN)
    if (m) { rolle = m[1] as Rolle; name = name.slice(0, m.index).trim() }
    return { nummer, name, rolle }
  })
}

export function zeilenZuText(zeilen: TeamZeile[]): string {
  return zeilen
    .filter((z) => z.nummer.trim() || z.name.trim())
    .map((z) => `${z.nummer.trim()} = ${z.name.trim()}${z.rolle ? ` (${z.rolle})` : ""}`)
    .join("\n")
}

/** Wie das Backend vergleicht (`nummer_kurz`): letzte neun Ziffern. */
export function nummerKurz(nummer: string): string {
  const ziffern = (nummer || "").replace(/\D/g, "")
  return ziffern.length >= 9 ? ziffern.slice(-9) : ""
}

export function zeilenFehler(zeilen: TeamZeile[]): (string | null)[] {
  const gesehen = new Map<string, number>()
  return zeilen.map((z, i) => {
    if (!z.nummer.trim() && !z.name.trim()) return null
    if (!z.name.trim()) return "Name fehlt"
    const kurz = nummerKurz(z.nummer)
    if (!kurz) return "Nummer zu kurz — mit Vorwahl, z. B. 0176 12345678"
    if (gesehen.has(kurz)) return `Nummer steht schon in Zeile ${gesehen.get(kurz)! + 1}`
    gesehen.set(kurz, i)
    return null
  })
}
